var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 156,
    viewBox: "0 0 322 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_877_504",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 322,
    height: 156
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00642395H322V155.046H0V0.00642395Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_877_504)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6935 76.5278H83.8508C86.1 76.5278 87.8548 76.0131 89.1133 74.9854C90.4098 73.9568 91.0577 72.5562 91.0577 70.7825C91.0577 68.9734 90.4098 67.5727 89.1133 66.5796C87.8548 65.5519 86.1 65.0372 83.8508 65.0372H70.6935V76.5278ZM93.1745 59.2387C90.6956 58.1393 87.7595 57.59 84.3652 57.59H60.9688V97.4883H70.6935V83.975H84.3652C87.7595 83.975 90.6956 83.4258 93.1745 82.3263C95.6533 81.1914 97.5405 79.649 98.8371 77.6982C100.173 75.7119 100.84 73.4067 100.84 70.7825C100.84 68.1584 100.173 65.8531 98.8371 63.8669C97.5405 61.8806 95.6533 60.3382 93.1745 59.2387Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.786 57.59V65.6228H116.221V97.4883H106.496V57.59H137.786Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.272 97.4883L158.758 88.6705L139.258 57.59H149.954L164.109 80.2355L178.156 57.59H188.682L163.798 97.4883H153.272Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.454 81.6698C214.37 80.5589 214.919 79.2804 215.099 77.8355H210.901C210.738 78.6567 210.386 79.3646 209.846 79.9582C209.306 80.5358 208.611 80.985 207.76 81.3048C206.909 81.6087 205.919 81.7611 204.79 81.7611C203.497 81.7611 202.377 81.5405 201.428 81.0993C200.496 80.643 199.775 80.0034 199.268 79.1821C198.761 78.3449 198.507 77.3633 198.507 76.2372C198.507 75.1112 198.761 74.1376 199.268 73.3163C199.775 72.4791 200.496 71.8403 201.428 71.3991C202.377 70.942 203.497 70.7143 204.79 70.7143C205.919 70.7143 206.909 70.8738 207.76 71.1936C208.611 71.5125 209.306 71.9697 209.846 72.5632C210.386 73.1409 210.738 73.8337 210.901 74.6399H215.099C214.919 73.179 214.37 71.9006 213.454 70.8055C212.554 69.7096 211.36 68.8574 209.871 68.2487C208.398 67.6401 206.713 67.3362 204.815 67.3362C202.72 67.3362 200.879 67.7092 199.292 68.4543C197.721 69.2002 196.494 70.2421 195.611 71.5816C194.727 72.9052 194.285 74.4574 194.285 76.2372C194.285 78.018 194.727 79.5772 195.611 80.9168C196.494 82.2404 197.721 83.2751 199.292 84.0211C200.879 84.7662 202.72 85.1392 204.815 85.1392C206.713 85.1392 208.398 84.8353 209.871 84.2258C211.36 83.6171 212.554 82.7657 213.454 81.6698Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.653 81.6929C228.994 81.6929 230.148 81.4723 231.113 81.0311C232.095 80.5899 232.848 79.9582 233.371 79.1369C233.911 78.3148 234.182 77.3482 234.182 76.2381C234.182 75.1272 233.911 74.1606 233.371 73.3393C232.848 72.5172 232.095 71.8855 231.113 71.4443C230.148 71.0031 228.994 70.7825 227.653 70.7825C226.327 70.7825 225.174 71.0031 224.192 71.4443C223.211 71.8855 222.45 72.5172 221.91 73.3393C221.387 74.1606 221.125 75.1272 221.125 76.2381C221.125 77.3482 221.387 78.3148 221.91 79.1369C222.45 79.9582 223.211 80.5899 224.192 81.0311C225.174 81.4723 226.327 81.6929 227.653 81.6929ZM227.653 85.1392C225.51 85.1392 223.628 84.7662 222.008 84.0211C220.404 83.2751 219.153 82.2404 218.252 80.9168C217.353 79.5781 216.902 78.018 216.902 76.2381C216.902 74.4574 217.353 72.9052 218.252 71.5816C219.153 70.243 220.404 69.2002 222.008 68.4543C223.628 67.7092 225.51 67.3362 227.653 67.3362C229.797 67.3362 231.67 67.7092 233.273 68.4543C234.893 69.2002 236.153 70.243 237.053 71.5816C237.953 72.9052 238.403 74.4574 238.403 76.2381C238.403 78.018 237.953 79.5781 237.053 80.9168C236.153 82.2404 234.893 83.2751 233.273 84.0211C231.67 84.7662 229.797 85.1392 227.653 85.1392Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.889 81.3739V67.679H255.741V81.3739H245.458V67.679H241.285V84.7972H259.202V88.2896H263.104V81.3739H259.889Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.988 71.1025H270.327V84.7974H274.475V71.1025H281.788V67.6783H262.988V71.1025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.697 77.7214H299.33V74.7543H288.697L288.045 70.897H299.968V67.6783H283.523L284.948 76.2374L283.523 84.7974H300.09V81.5787H288.045L288.697 77.7214Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.197 75.8884L321.996 84.7974H316.866L311.55 78.4833L306.215 84.7974H301.184L309.03 75.8786L301.748 67.6792H306.926L311.67 73.258L316.351 67.6792H321.431L314.197 75.8884Z",
    fill: "#FAFAFA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.102 26.8121C131.676 29.5426 134.955 32.592 137.891 35.916L147.8 28.3448C144.333 24.4218 140.461 20.8205 136.243 17.5974L128.102 26.8121Z",
    fill: "url(#paint0_linear_877_504)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.824 14.7371C108.278 15.9907 112.547 17.6465 116.583 19.6567L122.638 9.14329C117.866 6.76542 112.814 4.80839 107.543 3.32267L103.824 14.7371Z",
    fill: "url(#paint1_linear_877_504)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3692 0.000400543C80.6112 0.000400543 77.8847 0.125312 75.1953 0.36806L76.4376 12.2388C78.7144 12.0323 81.0266 11.9269 83.3692 11.9269C85.7118 11.9269 88.0239 12.0323 90.2998 12.2388L91.5421 0.36806C88.8536 0.125312 86.1271 0.000400543 83.3692 0.000400543Z",
    fill: "url(#paint2_linear_877_504)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0586 9.14329L50.1128 19.6567C54.1502 17.6465 58.419 15.9907 62.8718 14.7371L59.1535 3.32267C53.8825 4.80839 48.8314 6.76542 44.0586 9.14329Z",
    fill: "url(#paint3_linear_877_504)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9219 28.3448L28.8305 35.916C31.7657 32.592 35.0466 29.5426 38.6191 26.8121L30.4786 17.5974C26.2602 20.8205 22.3877 24.4218 18.9219 28.3448Z",
    fill: "url(#paint4_linear_877_504)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57422 55.0164L15.8474 58.4751C17.1973 54.3333 18.9759 50.3625 21.1385 46.6088L9.83417 40.9778C7.27722 45.4163 5.17183 50.1136 3.57422 55.0164Z",
    fill: "url(#paint5_linear_877_504)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 77.5173C0 80.0821 0.133373 82.6176 0.395355 85.1187L13.1591 83.9634C12.9381 81.8451 12.8238 79.6958 12.8238 77.5173C12.8238 75.3388 12.9381 73.1886 13.1591 71.0712L0.395355 69.9168C0.133373 72.4169 0 74.9525 0 77.5173Z",
    fill: "url(#paint6_linear_877_504)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57422 100.036C5.17183 104.938 7.27722 109.636 9.83417 114.074L21.1385 108.443C18.9759 104.689 17.1973 100.72 15.8474 96.5778L3.57422 100.036Z",
    fill: "url(#paint7_linear_877_504)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9258 126.699C22.3916 130.622 26.2641 134.224 30.4825 137.447L38.623 128.231C35.0506 125.503 31.7696 122.451 28.8344 119.128L18.9258 126.699Z",
    fill: "url(#paint8_linear_877_504)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0586 145.908C48.8314 148.285 53.8825 150.243 59.1535 151.729L62.8718 140.315C58.419 139.06 54.1502 137.406 50.1128 135.395L44.0586 145.908Z",
    fill: "url(#paint9_linear_877_504)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3692 143.12C81.0266 143.12 78.7144 143.013 76.4376 142.808L75.1953 154.677C77.8847 154.921 80.6112 155.046 83.3692 155.046C86.1271 155.046 88.8536 154.921 91.5421 154.677L90.2998 142.808C88.0239 143.013 85.7118 143.12 83.3692 143.12Z",
    fill: "url(#paint10_linear_877_504)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.824 140.315L107.543 151.729C112.814 150.243 117.866 148.285 122.638 145.908L116.583 135.395C112.547 137.406 108.278 139.06 103.824 140.315Z",
    fill: "url(#paint11_linear_877_504)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.102 128.231L136.243 137.447C140.461 134.224 144.333 130.622 147.8 126.699L137.891 119.128C134.955 122.451 131.676 125.503 128.102 128.231Z",
    fill: "url(#paint12_linear_877_504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_877_504",
    x1: 153.372,
    y1: 12.1578,
    x2: 18.4309,
    y2: 160.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_877_504",
    x1: 131.848,
    y1: -7.35926,
    x2: -3.09263,
    y2: 141.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_877_504",
    x1: 114.067,
    y1: -23.5335,
    x2: -20.874,
    y2: 125.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_877_504",
    x1: 102.095,
    y1: -34.3889,
    x2: -32.8454,
    y2: 114.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_877_504",
    x1: 97.7469,
    y1: -38.3379,
    x2: -37.194,
    y2: 110.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_877_504",
    x1: 101.603,
    y1: -34.8358,
    x2: -33.3379,
    y2: 113.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_877_504",
    x1: 113.128,
    y1: -24.3784,
    x2: -21.8128,
    y2: 124.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_877_504",
    x1: 130.657,
    y1: -8.46278,
    x2: -4.28414,
    y2: 140.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_877_504",
    x1: 151.943,
    y1: 10.855,
    x2: 17.0025,
    y2: 159.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_877_504",
    x1: 173.438,
    y1: 30.3793,
    x2: 38.4972,
    y2: 179.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_877_504",
    x1: 191.261,
    y1: 46.5482,
    x2: 56.32,
    y2: 195.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_877_504",
    x1: 203.191,
    y1: 57.4089,
    x2: 68.25,
    y2: 206.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_877_504",
    x1: 207.564,
    y1: 61.3504,
    x2: 72.6231,
    y2: 209.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ECCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7C8E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/ргу.18ed6c3f118fa0407d35957f48e7a5bd.svg";
export { ForwardRef as ReactComponent };